export default "__VITE_ASSET__bab76a10__"